import { useTranslation } from 'react-i18next'

import type { DraftEditorLabels } from './components/template-draft-editor'

/** The draft editor's words, in the application's language. */
export function useDraftEditorLabels(): DraftEditorLabels {
  const { t } = useTranslation()
  return {
    title: t('templates.draft.title'),
    description: t('templates.draft.description'),
    whenToUse: t('templates.draft.whenToUse'),
    whenToUseHint: t('templates.draft.whenToUseHint'),
    categories: t('templates.draft.categories'),
    items: t('templates.draft.items'),
    itemPosition: (position, count) =>
      t('templates.draft.itemPosition', { position, count }),
    previousItem: t('templates.draft.previousItem'),
    nextItem: t('templates.draft.nextItem'),
    itemName: t('templates.draft.itemName'),
    itemDescription: t('templates.draft.itemDescription'),
    includeRows: t('templates.draft.includeRows'),
    includeRowsHint: t('templates.draft.includeRowsHint'),
    includeRowsFixed: t('templates.draft.includeRowsFixed'),
    required: t('templates.draft.required'),
    requiredHint: t('templates.draft.requiredHint'),
    error: {
      required: t('templates.draft.error.required'),
      tooLong: t('templates.draft.error.tooLong'),
    },
  }
}
